type Value = string | number | boolean | null | undefined;
export const naturalCompare = (valueA: Value, valueB: Value) => {
  if (typeof valueA === 'number' && typeof valueB === 'number') {
    return valueA - valueB;
  }
  // eslint-disable-next-line no-undefined
  return `${valueA ?? ''}`.localeCompare(`${valueB ?? ''}`, undefined, { numeric: true });
};
